import { render } from "./ProfiloUtenteView.vue?vue&type=template&id=68ad17ee"
import script from "./ProfiloUtenteView.vue?vue&type=script&lang=js"
export * from "./ProfiloUtenteView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__